/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  useDisclosure,
  useToast,
  VStack,
  useBreakpointValue,
} from '@chakra-ui/react';
import { GoArrowLeft } from 'react-icons/go';
import ePub, { Rendition } from 'epubjs';
import Navigation from 'epubjs/types/navigation';
import { useCallback, useEffect, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { IoApps } from 'react-icons/io5';
import { MainTemplate } from '../templates/MainTemplate';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetReadingBooksDetail } from '@partiu/api/bookstore/hooks';
import { saveBookProgress } from '../utils';
import Section from 'epubjs/types/section';
import { axiosInstanceV3 } from '@partiu/api/axios';

export function BookReader() {
  const [bookNavigation, setBookNavigation] = useState<Navigation>();
  const [pageData, setPageData] = useState({ label: '' });
  const [sectionData, setSectionData] = useState<[string, string][]>([]);
  const [progressData, setProgressData] = useState({ currentPage: 0, totalPages: 0 });
  const [rendition, setRendition] = useState<Rendition>();
  const { id } = useParams();
  const drawerDisclosure = useDisclosure();

  const [progessLoading, setProgessLoading] = useState(0);
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const modalDisclosure = useDisclosure();

  const { data: ReadingBook, isError } = useGetReadingBooksDetail(id || '');

  const book = ReadingBook?.book;
  const isBestSeller = book?.isBestSeller;

  const nav = useNavigate();

  const handleSendBookProgress = useCallback(
    async (page: number, progress: number) => {
      await axiosInstanceV3.patch(`/bookstore/reading-books/${id}/update-by-book`, {
        current_page: page,
        progress: progress,
      });
    },
    [id]
  );

  const handleGetBookStream = async (bookId: string) => {
    try {
      setLoading(true);
      const { data, headers } = await axiosInstanceV3.get(`/bookstore/books/${bookId}/read-stream/`, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent: any) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgessLoading(percentCompleted);
        },
      });

      const file: any = new Blob([data], { type: headers['content-type'] });
      const book = ePub(file);
      const renditionInstance = book.renderTo('area', {
        flow: 'scrolled-doc', // Corrigido para navegação por página
        width: '100%',
        height: '100%',
        snap: false,
        allowScriptedContent: true,
      });

      // Configuração básica sem estilos CSS customizados

      console.log(renditionInstance);
      setRendition(renditionInstance);
      book.loaded.navigation.then(function (navigation) {
        setSectionData(navigation.toc.map((t) => [t.label, t.href.split('../').pop() as string]));
        setBookNavigation(navigation);
      });

      setLoading(false);
    } catch (error) {
      nav(-1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao baixar o livro',
        description: 'Ocorreu um erro ao tentar baixar o livro, tente novamente mais tarde',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      nav('/');
    }
  }, [isError]);

  useEffect(() => {
    if (!id) {
      return;
    }
    handleGetBookStream(id);
  }, []);

  const isMobile = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    if (!rendition || !bookNavigation || !book) return;
    const lastPage = ReadingBook?.currentPage || 0;

    rendition.display(lastPage);

    // Função modularizada para melhorar imagens
    const enhanceImages = () => {
      const iframe = document.querySelector('#area iframe') as HTMLIFrameElement;
      if (iframe?.contentDocument) {
        const images = iframe.contentDocument.querySelectorAll('img');
        images.forEach(img => {
          img.removeAttribute('width');
          img.removeAttribute('height');
          // Responsividade para mobile e desktop
          Object.assign(img.style, {
            maxWidth: isMobile ? '98vw' : '90%',
            width: isMobile ? '98vw' : '90%',
            minWidth: isMobile ? '0' : '400px',
            height: 'auto',
            minHeight: isMobile ? '0' : '300px',
            display: 'block',
            margin: isMobile ? '16px auto' : '20px auto',
            borderRadius: '8px',
            objectFit: 'contain',
            boxSizing: 'border-box',
            background: '#fff',
          });
          img.onload = () => {
            const containerWidth = iframe.contentDocument!.body.clientWidth;
            const viewportHeight = window.innerHeight;
            const idealWidth = isMobile ? containerWidth * 0.98 : Math.max(containerWidth * 0.7, 300);
            const maxWidth = isMobile ? containerWidth : containerWidth * 0.9;
            img.style.width = Math.min(idealWidth, maxWidth) + 'px';
            img.style.maxHeight = (viewportHeight * 0.5) + 'px';
          };
          if (img.complete && img.onload) {
            img.onload(new Event('load'));
          }
        });
      }
    };

    setTimeout(enhanceImages, 500);

    //@ts-expect-error Spine tem length sim
    const progress = Math.floor((lastPage * 100) / rendition.book.spine.length);

    if (progress < 10) {
      localStorage.setItem('continueReadingAccepted', 'false');
    }

    rendition.on('rendered', (section: Section) => {
      const href = '../' + section.href;
      const pageData = bookNavigation.get(href);

      //@ts-expect-error Spine tem length sim
      const progress = section.index / (rendition.book.spine.length - 1);

      setProgressData({
        currentPage: section.index + 1, // Corrige para começar em 1
        //@ts-expect-error Spine tem length sim
        totalPages: rendition.book.spine.length,
      });

      handleSendBookProgress(section.index, Math.floor(progress * 100));

      if ((progress * 100) >= 10 && isBestSeller && localStorage.getItem('continueReadingAccepted') !== 'true') {
        modalDisclosure.onOpen();
        localStorage.setItem('continueReadingAccepted', 'true');
      }

      saveBookProgress(book, Math.floor(progress * 100).toString(), section.index.toString());

      // Aplicar melhorias nas imagens de cada nova página
      setTimeout(() => {
        enhanceImages();
      }, 200);

      if (pageData?.label)
        setPageData({
          label: pageData.label,
        });
    });
  }, [isBestSeller, rendition, bookNavigation, ReadingBook, isMobile]);

  return (
    <MainTemplate noShadow hideBottomMenu>
      <Drawer placement="left" {...drawerDisclosure} size={isMobile ? 'full' : 'xs'}>
        <DrawerOverlay backdropFilter={'blur(10px)'} />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Sessões</DrawerHeader>
          <DrawerBody>
            <VStack align={'flex-start'} spacing={2}>
              {sectionData.map((sd) => (
                <Text
                  key={sd[0]}
                  cursor={'pointer'}
                  onClick={() => {
                    rendition?.display(sd[1]);
                    drawerDisclosure.onClose();
                  }}
                  textDecor={'underline'}
                  fontSize={isMobile ? '18px' : '16px'}
                >
                  {sd[0]}
                </Text>
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <VStack
        backgroundColor={'rgba(255,255,255,0.95)'}
        backdropFilter={'blur(10px)'}
        height={isMobile ? '50px' : '60px'}
        width={'100%'}
        borderBottom="1px solid #dedede"
        justify={'center'}
        
      >
        <HStack width={'95%'} alignItems={'center'} justifyContent={'space-between'}>
          <HStack width={'80%'}>
            <GoArrowLeft cursor={'pointer'} onClick={() => window.history.back()} size={isMobile ? '22px' : '25px'} />
            <Heading width={'80%'} whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflowX={'clip'} fontSize={isMobile ? '16px' : '18px'}>
              {book?.title}
            </Heading>
          </HStack>
          <Box justifyContent={'center'} alignItems={'center'} display={'flex'} width={isMobile ? '28px' : '30px'} height={isMobile ? '28px' : '30px'}>
            <IoApps cursor={'pointer'} size={isMobile ? '22px' : '25px'} onClick={drawerDisclosure.onOpen} />
          </Box>
        </HStack>
      </VStack>
      <VStack width={'100%'}>
        {loading && (
          <VStack width={'100%'} marginTop={isMobile ? '60px' : '80px'} height={'100%'} justify={'center'} align={'center'}>
            <CircularProgress size={30} color="black" isIndeterminate />
            <Text fontSize={'16px'} fontWeight={'bold'} color={'black'}>
              Carregando: {progessLoading}%
            </Text>
          </VStack>
        )}
        <Box 
          w={'100%'} 
          maxW={'100%'}
          marginTop={isMobile ? '50px' : '60px'} 
          paddingBottom={isMobile ? '90px' : '130px'} 
          paddingX={isMobile ? '2px' : { base: '10px', md: '20px', lg: '40px' }}
          id="area"
          sx={{
            '& iframe': {
              width: '100% !important',
              maxWidth: '100% !important',
              minHeight: isMobile ? '60vh' : '70vh',
            }
          }}
        ></Box>
        <Box
          zIndex={100}
          pos={'fixed'}
          bottom={'0px'}
          right={'0px'}
          height={'50%'}
          cursor={'pointer'}
          width={isMobile ? '15%' : '10%'}
          onClick={() => rendition?.next()}
        />
        <Box
          zIndex={100}
          pos={'fixed'}
          bottom={'0px'}
          cursor={'pointer'}
          left={'0px'}
          height={'50%'}
          width={isMobile ? '15%' : '10%'}
          onClick={() => rendition?.prev()}
        />
        {!loading && (
          <VStack
            backgroundColor={'rgba(255,255,255,0.85)'}
            backdropFilter={'blur(10px)'}
            pos={'fixed'}
            bottom="0px"
            height={isMobile ? '55px' : '70px'}
            width="100%"
            borderTop="1px solid #dedede"
            justify={'center'}
            paddingBottom={'0px'}
          >
            <HStack width={'95%'}>
              <FaChevronLeft />
              <Spacer />
              <VStack spacing={0} maxW={isMobile ? '70vw' : 'none'}>
                <Heading fontSize={isMobile ? '14px' : '16px'}>
                  {pageData.label.slice(0, 40)} {pageData.label.length > 40 && '...'}
                </Heading>
                <Text color="#a9a9a9" fontSize={isMobile ? '10px' : '12px'}>
                  Página {progressData.currentPage} de {progressData.totalPages} (
                  {Math.floor((progressData.currentPage * 100) / (progressData.totalPages))}%
                  )
                </Text>
              </VStack>
              <Spacer />
              <FaChevronRight />
            </HStack>
          </VStack>
        )}
      </VStack>
      <Modal isOpen={modalDisclosure.isOpen} onClose={() => modalDisclosure.onClose()} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Você chegou a 10% do livro</ModalHeader>
          <ModalBody>
            <Text>Deseja continuar lendo ou fechar?</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => nav(-1)} mr={3}>
              Fechar
            </Button>
            <Button colorScheme="blue" onClick={() => modalDisclosure.onClose()}>
              Continuar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </MainTemplate>
  );
}
